import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { WfBreadcrumb } from "../components/WfBreadcrumb";
import { WfExplainer } from "../components/WfExplainer";
import { WordFrequencyTool } from "../components/WordFrequencyTool";

export function WordFrequencyPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <WfBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.wf_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.wf_intro()}
          </p>
        </header>

        <WordFrequencyTool />

        <WfExplainer
          howTo={m.wf_howto()}
          faqs={[
            { q: m.wf_faq1_q(), a: m.wf_faq1_a() },
            { q: m.wf_faq2_q(), a: m.wf_faq2_a() },
            { q: m.wf_faq3_q(), a: m.wf_faq3_a() },
            { q: m.wf_faq4_q(), a: m.wf_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
